import { Dispatch, SetStateAction } from "react";
import { fetchWithAuth } from "../../../api-client/api_client";

const getCanaryTestCount = async (setCanaryTestCount: Dispatch<SetStateAction<number | null>>) => {
  await fetchWithAuth({
    path: `/integrations/canary-test-dashboard`,
    method: "GET",
    onResponse: (data) => {
      setCanaryTestCount(data.dashboard_rows.length || 0);
    },
    onError: () => {
      setCanaryTestCount(0);
    },
  });
};

export { getCanaryTestCount };
